import { render } from "./CashTableAccountant.vue?vue&type=template&id=ab3d4b24"
import script from "./CashTableAccountant.vue?vue&type=script&lang=js"
export * from "./CashTableAccountant.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/apps/crm/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__